/** Адрес, куда SDK шлёт события напрямую. Его же режут блокировщики — пробой проверяем именно его. */
export const AMPLITUDE_PROBE_URL = 'https://api2.amplitude.com/2/httpapi';

/** Дольше ждать нельзя: до ответа SDK не инициализирован. Блокировщик отказывает за миллисекунды. */
export const AD_BLOCKER_PROBE_TIMEOUT_MS = 1500;

/**
 * Пробный запрос к домену Amplitude: `true` — запрос отрезан (блокировщик, корпоративный фильтр), события напрямую не
 * дойдут. По нему `initAmplitude` решает, слать ли через наш домен, и ставит пользователю `has_ad_blocker`.
 *
 * `no-cors` + `HEAD`: ответ непрозрачный, читать его не нужно — важно только, ушёл ли запрос. Блокировщик роняет
 * `fetch` с `TypeError`. Таймаут считается «не заблокировано»: медленная сеть — не блокировщик, а прямой путь
 * сохраняет геолокацию (через прокси Amplitude видит IP нашего сервера).
 *
 * Голый `fetch` вне репозитория — сознательно: это инфраструктура аналитики до старта приложения, а не запрос фичи
 * к нашему бэкенду (`.claude/rules/api-and-state.md`).
 */
export async function detectAdBlocker(timeoutMs = AD_BLOCKER_PROBE_TIMEOUT_MS): Promise<boolean> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  try {
    await fetch(AMPLITUDE_PROBE_URL, { method: 'HEAD', mode: 'no-cors', cache: 'no-store', signal: controller.signal });
    return false;
  } catch {
    return !controller.signal.aborted;
  } finally {
    clearTimeout(timer);
  }
}
